import { render, staticRenderFns } from "./WeekSelector.vue?vue&type=template&id=c407f8e4&"
import script from "./WeekSelector.vue?vue&type=script&lang=js&"
export * from "./WeekSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports